import { GetServerSidePropsContext, PreviewData } from 'next';
import { apiIntegration } from '@lemon-io/ui-kit';
import { AxiosError } from 'axios';
import { ParsedUrlQuery } from 'querystring';

import { extractToken } from './utils';

const baseURL =
  globalThis.window === undefined
    ? (process.env.NEXT_PUBLIC_APP_URL as string)
    : '';

export const httpClient = apiIntegration.createHttpClient<{
  server?: boolean;
  nextContext?: GetServerSidePropsContext<ParsedUrlQuery, PreviewData>;
}>({
  baseURL,
  mergeHeaders: config => ({
    // TODO: extend with auth-key extracting from storage
    // E.g: Make map of token to auth-key, so we can make it consistent.
    // localStorage.setItem(`${token}:authKey`: profile.apiKey);
    ...(!config.server && { token: extractToken(config.nextContext) }),
  }),
  mutateAxiosInstance: axios => {
    axios.interceptors.response.use(
      response => response,
      error => {
        const err = error as AxiosError;

        if (!('response' in error)) {
          // No response received, handle "No Internet connection" error
          // eslint-disable-next-line prefer-promise-reject-errors
          return Promise.reject({
            response: {
              statusText: 'No Internet Connection',
            },
          });
        }

        // if prod and Unauthorized
        if (
          process.env.NODE_ENV === 'production' &&
          err.response?.status === 401 &&
          typeof window !== 'undefined'
        ) {
          window.location.href = `${
            process.env.APP_LEMON_URL as string
          }/auth/login`;
        }

        return Promise.reject(error);
      }
    );
    return axios;
  },
});
